export const checkTokenLifetime = (
    tokenLifetime: number,
    tokenExpirationDate: number
): boolean => {
    const remainingTime = tokenExpirationDate - Date.now();
    return remainingTime / tokenLifetime < 0.3;
};
